"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineAlert = exports.MessageClass = exports.ContentClass = exports.InlineAlertType = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var TypeStyle = require("typestyle");
var StatusIcons_1 = require("../../icons/StatusIcons");
var TabStyles_1 = require("../../styles/TabStyles");
var Declarative_1 = require("../../utils/Declarative");
var AlertStyles_1 = require("../AlertStyles");
Object.defineProperty(exports, "InlineAlertType", { enumerable: true, get: function () { return AlertStyles_1.AlertType; } });
var AlertTestId = 'InlineAlert';
var IconClass = 'statusIcon';
exports.ContentClass = 'contentContainer';
exports.MessageClass = 'alertMessage';
var AlertBaseStyleName = TypeStyle.style({
    borderRadius: 2,
    borderLeft: "4px solid transparent",
    boxSizing: 'border-box',
    color: TabStyles_1.TabStyles.Typography.Color.Primary,
    display: 'flex',
    fontSize: '12px',
    letterSpacing: '0.2px',
    lineHeight: 1.5,
    $nest: (_a = {},
        _a["& ." + IconClass] = {
            flexShrink: 0,
            marginLeft: 8,
            marginTop: 5,
        },
        _a["& ." + exports.ContentClass] = {
            display: 'flex',
            flexGrow: 1,
        },
        _a['& button'] = {
            margin: 0,
        },
        _a),
});
exports.InlineAlert = React.forwardRef(function (props, ref) {
    var children = props.children, className = props.className, interactiveElement = props.interactiveElement, testId = props.testId, type = props.type, htmlProps = tslib_1.__rest(props, ["children", "className", "interactiveElement", "testId", "type"]);
    return (React.createElement("div", tslib_1.__assign({ "aria-atomic": true, "aria-live": 'polite' }, htmlProps, { className: TypeStyle.classes(AlertStyles_1.AlertBaseColorStyleName, AlertBaseStyleName, className, type), "data-tb-test-id": Declarative_1.makeTestId(testId, AlertTestId), ref: ref }),
        React.createElement(StatusIcons_1.StatusIcon, { type: type, className: IconClass }),
        React.createElement("div", { key: 'contentContainer', className: exports.ContentClass },
            React.createElement("div", { className: exports.MessageClass }, children),
            interactiveElement)));
});
//# sourceMappingURL=InlineAlertBase.js.map